@if (authService.isLoading()) {
  <div class="min-h-screen flex flex-col items-center justify-center bg-background text-foreground">
    <div class="flex flex-col items-center space-y-4">
      <div
        class="size-12 rounded-full border-4 border-primary/20 border-t-primary animate-spin"
      ></div>
      <p class="text-sm font-medium text-muted-foreground animate-pulse">
        {{ 'common.loading' | translate }}
      </p>
    </div>
  </div>
} @else if (isPublicRoute() || !authService.isAuthenticated()) {
  <div class="min-h-screen flex flex-col bg-background text-foreground">
    <main class="flex-1 min-w-0 flex flex-col">
      <router-outlet />
    </main>
    <tf-footer />
  </div>
} @else {
  <div
    class="h-screen bg-background text-foreground transition-colors duration-300 flex flex-col overflow-hidden animate-in fade-in-50 duration-500"
  >
    <z-toast
      [position]="'bottom-right'"
      [duration]="3000"
      [visibleToasts]="3"
      [richColors]="true"
    />

    <app-company-switcher />

    <tf-header
      [isDark]="isDarkMode()"
      [notificationsOpen]="isNotificationsOpen()"
      [unreadCount]="unreadNotificationsCount()"
      [notifications]="notifications()"
      [profileOpen]="isProfileOpen()"
      [userName]="userName()"
      [userEmail]="userEmail()"
      [userInitials]="userInitials()"
      [userPhoto]="userPhoto()"
      (openMobile)="openMobileDrawer()"
      (toggleDarkMode)="toggleDarkMode()"
      (toggleNotifications)="isNotificationsOpen.update((v) => !v)"
      (markAllNotificationsRead)="markAllNotificationsAsRead()"
      (markNotificationRead)="markNotificationAsRead($event)"
      (dismissNotification)="dismissNotification($event)"
      (clearAllNotifications)="clearAllNotifications()"
      (toggleProfile)="isProfileOpen.update((v) => !v)"
      (goToProfileSettings)="goToProfileSettings()"
      (handleLogout)="handleLogout()"
    />

    <div class="flex flex-1 min-h-0 overflow-hidden">
      <tf-sidebar (logout)="handleLogout()" />

      <main class="relative flex-1 min-w-0 flex flex-col bg-background overflow-y-auto">
        <div class="p-6 lg:p-8 flex flex-col flex-1">
          <router-outlet />
        </div>
      </main>
    </div>

    <tf-footer />
  </div>

  <ng-template #mobileMenuTemplate let-sheetRef="sheetRef">
    <div class="flex flex-col h-full py-4 px-2 space-y-6 overflow-y-auto">
      @for (section of navService.visibleNavSections(); track section.id) {
        <div class="space-y-1.5">
          @if (section.title) {
            <p
              class="text-[11px] font-semibold text-muted-foreground/70 px-3 uppercase tracking-wider"
            >
              {{ section.title | translate }}
            </p>
          }
          <nav class="space-y-1">
            @for (item of section.items; track item.id) {
              <tf-sidebar-item [item]="item" (itemClicked)="sheetRef.close()" />
            }
          </nav>
        </div>
      }

      <div class="mt-auto p-4 bg-primary/10 rounded-lg border border-primary/20">
        <div class="flex items-center gap-2 mb-2">
          <ng-icon name="lucideLayers" class="size-4 text-primary" />
          <span class="text-xs font-bold uppercase tracking-wider text-primary">{{
            brand.name
          }}</span>
        </div>
        <p class="text-xs text-muted-foreground leading-relaxed">
          {{ 'brand.description' | translate }}
        </p>
      </div>
    </div>
  </ng-template>
}
